const Services = [
  {
    title: "Espacios Diseñados a la medida de las necesidades",
    text: "Selling your property should be a rewarding experience, and at Estatein, we make sure it is. Our Property Selling Service is designed to maximize the value of your property, ensuring you get the best deal possible. Explore the categories below to see how we can help you at every step of your selling journey",
    firstBox: {
      icon: "/assets/services/a1.jpg",
      title: "DISEÑO RESIDENCIAL",
      text: "Desde la adquisición y desarrollo de unidades residenciales en condominios de alta innovación tecnológica en sustentabilidad y seguridad.",
    },
    secondBox: {
      icon: "/assets/services/a2.jpg",
      title: "DISEÑO COMERCIAL DE ALTA GAMA",
      text: "Desde street mall, centros comerciales, fashion shows y hasta esos pequeños landmarks que nos sorprenden en los rincones más cosmopolitas.",
    },
    thirdBox: {
      icon: "/assets/services/a3.jpg",
      title: "INNOVACIÓN EN PARQUES INDUSTRIALES",
      text: "Buscamos proponer con tecnología y poner en práctica los últimos avances en la mezcla perfecta de cuidado al medio ambiente y productividad.",
    },
    theFourthBox: {
      icon: "/assets/services/a4.jpg",
      title: "FLIPPINGS Y RENOVACIÓN DE UNIDADES Y COMPLEJOS HABITACIONALES",
      text: "Encontraremos esos lugares emblemáticos que revivirán emociones revitalizando los hervores de las zonas urbanas.",
    },
    theFiveBox: {
      icon: "/assets/services/a5.jpg",
      title: "HIGH END LUXURY DESIGN PARA LOS MÁS ALTOS ESTÁNDARES",
      text: "El lujo estará presente en nuestro catálogo de oportunidades donde podrás invertir en tus sueños.",
    },
    theSixBox: {
      icon: "/assets/services/a6.jpg",
      title: "PROYECTOS SUSTENTABLES, EL FUTURO ESTÁ EN NUESTRAS MANOS",
      text: "No es solo desarrollar, sino conservar e incluso desaparecer la huella de carbono en nuestras propuestas arquitectónicas para una herencia dignificante de nuestra era.",
    },
    lastBox: {
      title: "Unlock the Value of Your Property Today",
      text: "Ready to unlock the true value of your property? Explore our Property Selling Service categories and let us help you achieve the best deal possible for your valuable asset.",
    },
  },
  /* {
    title: "Effortless Property Management",
    text: "Owning a property should be a pleasure, not a hassle. Estatein's Property Management Service takes the stress out of property ownership, offering comprehensive solutions tailored to your needs. Explore the categories below to see how we can make property management effortless for you",
    firstBox: {
      icon: "/assets/services/icon5.png",
      title: "Tenant Harmony",
      text: "Our Tenant Management services ensure that your tenants have a smooth and reducing vacancies.",
    },
    secondBox: {
      icon: "/assets/services/icon6.png",
      title: "Maintenance Ease",
      text: "Say goodbye to property maintenance headaches. We handle all aspects of property upkeep. ",
    },
    thirdBox: {
      icon: "/assets/services/icon7.png",
      title: "Financial Peace of Mind",
      text: "Managing property finances can be complex. Our financial experts take care of rent collection ",
    },
    theFourthBox: {
      icon: "/assets/services/icon8.png",
      title: "Legal Guardian",
      text: "Stay compliant with property laws and regulations effortlessly.",
    },
    lastBox: {
      title: "Experience Effortless Property Management",
      text: "Ready to experience hassle-free property management? Explore our Property Management Service categories and let us handle the complexities while you enjoy the benefits of property ownership.",
    },
  }, */
];

export default Services;
